import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../app.service';
import { SnackbarComponent, SnackbarType } from '../shared/components/snackbar/snackbar.component';
import { AuthService } from '../shared/libs/auth/auth.service';

@Injectable()
export class UtilitiesService {
  private baseUrl: string;

  constructor(
    private appService: AppService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    private authService: AuthService
  ) {
    this.baseUrl = this.appService.utilsUrls.apiUrl;
  }

  public showSnackbar(message: string, type: SnackbarType = SnackbarType.Info, milliseconds?: number) {
    if (!milliseconds) {
      milliseconds = 3500;
    }
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(SnackbarComponent).create(this.injector);
    componentRef.instance.message = message;
    componentRef.instance.type = type;
    this.applicationRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    setTimeout(() => {
      componentRef.instance.show = true;
    });
    setTimeout(() => {
      componentRef.instance.show = false;
      setTimeout(() => {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
      }, 2000);
    }, milliseconds);
  }

  dateToString(date?: Date) {
    if (!date) return '';
    return (
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) +
      '-' +
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    );
  }

  setUtc(dateFormatted: string): string {
    return dateFormatted + 'Z';
  }

  removeUtc(dateString: any): string {
    return (dateString + '').replace(/Z/g, '');
  }
}
